/** MS-533 — the agreement row: required badge + open button, or the signed pill. */
import {
  AgreementRowCard,
  AgreementRowLeft,
  AgreementRowTitle,
  AgreementRequiredBadge,
  AgreementOpenButton,
  AgreementSignedPill,
} from "./styles";

interface RentalAgreementRowProps {
  accepted: boolean;
  isPhone: boolean;
  onOpen: () => void;
}

const RentalAgreementRow = ({ accepted, isPhone, onOpen }: RentalAgreementRowProps) => (
  <AgreementRowCard $isPhone={isPhone}>
    <AgreementRowLeft>
      <AgreementRowTitle>اتفاقية الإيجار</AgreementRowTitle>
      {!accepted && <AgreementRequiredBadge>مطلوب</AgreementRequiredBadge>}
    </AgreementRowLeft>
    {accepted ? (
      <AgreementSignedPill>✓ تم التوقيع</AgreementSignedPill>
    ) : (
      <AgreementOpenButton type="button" onClick={onOpen}>
        عرض وتوقيع الاتفاقية
      </AgreementOpenButton>
    )}
  </AgreementRowCard>
);

export default RentalAgreementRow;
